
export const getStyles = () => ({
  'back-button': {
    color: '#106ebe',
    height: '100%',
  },
  'reports-v4-summary-bar': {
    flexShrink: 0,
    alignItems: 'center',
    right: '0px',
    height: '45px',
    zIndex: '150',
    borderBottom: 'solid 1px #e1dfdd',
    background: '#f3f2f1',
  },
});
